import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, HostListener, Inject, OnDestroy, OnInit, Optional, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PrivateService } from 'app/core/services/private.service';
import { Observable, Subject } from 'rxjs';
import * as jspdf from 'jspdf';
import { TimeEntries } from 'app/shared/models/timeEntries';
import { Time } from 'app/shared/models/time';
import { DateTimeService } from 'app/core/services/date-time.service';
import * as platform from 'platform';
import { Account } from 'app/shared/models/account';
import { switchMap } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'app/core/authentication/authentication.service';
import { FingerprintAIO } from '@awesome-cordova-plugins/fingerprint-aio/ngx';
import { W } from '@angular/cdk/keycodes';

@Component({
  selector: 'gen-timesheet-dialog',
  templateUrl: './gen-timesheet-dialog.component.html',
  styleUrls: ['./gen-timesheet-dialog.component.scss']
})
export class GenTimesheetDialogComponent implements OnInit, OnDestroy {

  videoRef: any;
  timeType: any;
  lat: number;
  lng: number;
  isDisabled: boolean = false;
  locationAlert: string = null;
  isCameraLoading: boolean = false;
  displayName: any;
  timeEntries: TimeEntries;
  flexiTimeEntries: TimeEntries[] = [];
  time: Time;
  payrollDefinition: any;
  deviceModel: any;

  public triggerObservable: Subject<void> = new Subject<void>();
  showCamera: boolean = true;
  imageData: any;
  private isCapturing = false;
  permissionGranted: boolean = false;
  textLoading: string = null;
  yourDesiredHeight: number;
  yourDesiredWidth: number;
  facingMode: string = 'user';
  allowCameraSwitch = false;
  connectedUser: string;
  NoteGroup: FormGroup;
  clients: any[] = [];
  branches: any[] = [];
  accountInfo: Account;
  isLocationReady: boolean = false;
  isProcessing: boolean = false;

  constructor(public dialogRef: MatDialogRef<GenTimesheetDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private privateService: PrivateService, private http: HttpClient, private dateTimeService: DateTimeService
    , private cdr: ChangeDetectorRef, private formBuilder: FormBuilder, private authService: AuthService, @Optional() private faio: FingerprintAIO) {

    this.NoteGroup = this.formBuilder.group({
      client: [0],
      note: [''],
      card: [''],
      branch: [null, Validators.required]
    });
  }

  ngOnInit(): void {
    const accountInfo = localStorage.getItem('account');
    if (accountInfo) {
      this.accountInfo = JSON.parse(accountInfo);
    }
    this.videoRef = document.getElementById("video");
    if (this.data.location) {
      this.displayName = this.data.location;
      this.isLocationReady = true;
    } else {
      this.getLocation();
    }
    this.updateTime();
    const payrollDefinition = localStorage.getItem('payrollDefinition');
    if (payrollDefinition) {
      this.payrollDefinition = JSON.parse(payrollDefinition);
    }
    this.detectDeviceModel();
    this.checkCameraPermissions();
    this.updateWindowSize();
    this.getAccountInfo();
    this.getClients();
    this.loadBranches();
    this.getClientAndNoteInfo();
  }

  getClients() {
    this.privateService.getClients().subscribe({
      next: res => {
        this.clients = res;
      },
      error: err => {
        console.log(err);
      }
    });
  }

  loadBranches() {
    // Use branches passed from the home page if available
    if (this.data.branches && this.data.branches.length > 0) {
      this.branches = this.data.branches;
      if (this.data.branchId) {
        this.NoteGroup.get('branch')?.setValue(this.data.branchId);
      }
    } else {
      this.privateService.getBranches().subscribe({
        next: (res: any[]) => {
          this.branches = res;
          if (this.data.branchId) {
            this.NoteGroup.get('branch')?.setValue(this.data.branchId);
          }
        },
        error: err => console.log(err)
      });
    }
  }

  getClientAndNoteInfo() {
    if (this.data.timeType === 'Time Out') {
      const currentBranch = this.NoteGroup.get('branch')?.value;
      this.NoteGroup.get('branch')?.disable();
      this.privateService.getClientAndNoteInfo().subscribe({
        next: res => {
          this.NoteGroup.setValue({
            client: res.clientID,
            note: '',
            card: res.card,
            branch: currentBranch
          });
          this.NoteGroup.get('client').disable();
          this.NoteGroup.get('card').disable();
        },
        error: err => {
          console.log(err);
        }
      });
    } else {
      this.NoteGroup.get('client').enable();
      this.NoteGroup.get('card').enable();
      this.NoteGroup.get('branch')?.enable();

      const currentBranch = this.NoteGroup.get('branch')?.value;
      this.NoteGroup.reset({
        client: null,
        note: '',
        card: '',
        branch: currentBranch
      });
    }
  }

  getAccountInfo() {
    this.privateService.getAccount().subscribe((data: Account) => {
      this.connectedUser = data.name;
      localStorage.setItem('account', JSON.stringify(data));
    });
  }

  checkCameraPermissions() {
    this.textLoading = "Loading camera please wait."
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        this.permissionGranted = true;
        this.showCamera = true;
        this.cdr.detectChanges();
      })
      .catch((error) => {
        this.textLoading = "Failed to access camera. Please allow the permission."
        this.permissionGranted = false;
        this.showCamera = false;
        this.cdr.detectChanges();
      });
  }

  updateTime() {
    this.time = { ...this.data.dateTimeCopy };
  }

  detectDeviceModel() {
    const userAgent = window.navigator.userAgent;
    const info = platform.parse(userAgent);
    this.deviceModel = info.description;
  }
  onNoClick(): void {
    this.triggerObservable.complete();
    this.dialogRef.close();
  }

  getTimeType(): Observable<any> {
    return this.privateService.getTimeType();
  }

  getLocation() {
    if (navigator.geolocation) {
      const options = {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0
      };

      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.lat = position.coords.latitude;
          this.lng = position.coords.longitude;
          this.isLocationReady = true;
          this.isDisabled = false;
          this.locationAlert = null;
          this.reverseGeocode(this.lat, this.lng);
        },
        (error) => {
          console.error('Geolocation error:', error);
          this.isDisabled = true;
          this.isLocationReady = false;

          switch (error.code) {
            case error.PERMISSION_DENIED:
              this.locationAlert = "Location permission denied. Please enable location permissions in your device settings.";
              break;
            case error.POSITION_UNAVAILABLE:
              this.locationAlert = "Location information unavailable. Please check your GPS settings.";
              break;
            case error.TIMEOUT:
              this.locationAlert = "Location request timed out. Please try again.";
              break;
            default:
              this.locationAlert = "An unknown error occurred while getting location.";
          }
          this.displayName = "Location unavailable";
        },
        options
      );
    } else {
      this.isDisabled = true;
      this.isLocationReady = false;
      this.locationAlert = "Geolocation is not supported by this browser.";
      this.displayName = "Location not supported";
    }
  }

  async reverseGeocode(latitude: any, longitude: any) {
    const apiUrl = `https://photon.komoot.io/reverse?lat=${latitude}&lon=${longitude}&lang=en`;

    try {
      const response = await fetch(apiUrl);

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const result = await response.json();

      if (result?.features?.length > 0) {
        const props = result.features[0].properties;

        const parts = [
          props.name,
          props.locality,
          props.city || props.town || props.village || props.municipality,
          props.state,
          props.country,
          props.postcode
        ].filter(Boolean);

        this.displayName = parts.length > 0
          ? parts.join(', ')
          : `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`;
      } else {
        this.displayName = `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`;
      }

      this.isDisabled = false;
      this.isLocationReady = true;
      this.cdr.detectChanges();

    } catch (error) {
      console.error('Geocode error:', error);
      this.displayName = `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`;
      this.isDisabled = false;
      this.isLocationReady = true;
      this.cdr.detectChanges();
    }
  }

  public handleImageCapture(imageData: any): void {
    this.imageData = imageData;
    if (!this.payrollDefinition) {
      this.takePhoto();
    } else {
      this.takePhotoFlexi();
    }
  }

  public captureImage(): void {
    if (!this.isCapturing && this.isLocationReady) { // Add location check
      this.isCapturing = true;
      this.isProcessing = true;
      this.triggerObservable.next();
    }
  }

  takePhoto() {
    if (this.imageData && this.imageData.imageAsDataUrl) {
      const pdf = new jspdf.jsPDF();

      const pdfWidth = pdf.internal.pageSize.width;
      const pdfHeight = pdf.internal.pageSize.height;

      const imageWidth = pdfWidth - 40;
      const imageHeight = imageWidth - 15;

      const x = (pdfWidth - imageWidth) / 2;
      const y = 10;

      pdf.addImage(this.imageData.imageAsDataUrl, 'PNG', x, y, imageWidth, imageHeight);

      const text =
        this.data.timeType +
        ': ' +
        this.data.dateTimeCopy.date +
        ' ' +
        this.data.dateTimeCopy.time;
      const textWidth = pdfWidth - 20;
      const textX = (pdfWidth - textWidth) / 2;
      const textY = y + imageHeight + 10;

      pdf.text(text, textX, textY);

      const textName = 'Employee Name: ' + this.connectedUser;
      const textNameWidth = pdfWidth - 20;
      const textNameX = (pdfWidth - textNameWidth) / 2;
      const textNameY = textY + 10;
      const splitNameText = pdf.splitTextToSize(textName, textNameWidth);

      pdf.text(splitNameText, textNameX, textNameY)

      const textLocation = 'Location: ' + this.displayName;
      const textLocationWidth = pdfWidth - 20;
      const textLocationX = (pdfWidth - textLocationWidth) / 2;
      const textLocationY = textNameY + 10;
      const splitText = pdf.splitTextToSize(textLocation, textLocationWidth);

      pdf.text(splitText, textLocationX, textLocationY);

      const pdfContent = pdf.output('blob');

      const formData = new FormData();
      formData.append('image', pdfContent, 'photo.png');

      if (this.accountInfo.allowFingerprint) {
        this.faio.isAvailable({ requireStrongBiometrics: true }).then((available: string) => {
          this.faio.show({
            title: 'Biometric Authentication',
            subtitle: 'Please scan your fingerprint',
            disableBackup: true,
          }).then(result => {
            this.insertTime(formData);
          }).catch(err => {
            console.error('Authentication failed', err);
            this.isProcessing = false;
          });

        }).catch(err => {
          this.insertTime(formData);
        });
      } else {
        this.insertTime(formData);
      }
      this.isCapturing = false;
    } else {
      console.error('Invalid imageData format or no imageData available');
      this.isCapturing = false;
      this.isProcessing = false;
    }
  }

  takePhotoFlexi() {
    if (this.imageData && this.imageData.imageAsDataUrl) {
      const pdf = new jspdf.jsPDF();

      const pdfWidth = pdf.internal.pageSize.width;
      const pdfHeight = pdf.internal.pageSize.height;

      const imageWidth = pdfWidth - 20;
      const imageHeight = imageWidth - 5;

      const x = (pdfWidth - imageWidth) / 2;
      const y = 10;

      pdf.addImage(this.imageData.imageAsDataUrl, 'PNG', x, y, imageWidth, imageHeight);

      const text =
        this.data.timeType +
        ': ' +
        this.data.dateTimeCopy.date +
        ' ' +
        this.data.dateTimeCopy.time;
      const textWidth = pdfWidth - 20;
      const textX = (pdfWidth - textWidth) / 2;
      const textY = y + imageHeight + 10;

      pdf.text(text, textX, textY);

      const textName = 'Employee Name: ' + this.connectedUser;
      const textNameWidth = pdfWidth - 20;
      const textNameX = (pdfWidth - textNameWidth) / 2;
      const textNameY = textY + 10;
      const splitNameText = pdf.splitTextToSize(textName, textNameWidth);

      pdf.text(splitNameText, textNameX, textNameY)

      const textLocation = 'Location: ' + this.displayName;
      const textLocationWidth = pdfWidth - 20;
      const textLocationX = (pdfWidth - textLocationWidth) / 2;
      const textLocationY = textNameY + 10;
      const splitText = pdf.splitTextToSize(textLocation, textLocationWidth);

      pdf.text(splitText, textLocationX, textLocationY);

      const pdfContent = pdf.output('blob');

      const formData = new FormData();
      formData.append('image', pdfContent, 'photo.png');

      if (this.accountInfo.allowFingerprint) {
        this.faio.isAvailable({ requireStrongBiometrics: true }).then((available: string) => {
          this.faio.show({
            title: 'Biometric Authentication',
            subtitle: 'Please scan your fingerprint',
            disableBackup: true,
          }).then(result => {
            this.insertTimeFlexi(formData);
          }).catch(err => {
            console.error('Authentication failed', err);
            this.isProcessing = false;
          });

        }).catch(err => {
          this.insertTimeFlexi(formData);
        });
      } else {
        this.insertTimeFlexi(formData);
      }
      this.isCapturing = false;
    } else {
      console.error('Invalid imageData format or no imageData available');
      this.isCapturing = false;
      this.isProcessing = false;
    }
  }

  createTimeSheet(isCreated: boolean) {
    this.privateService.createTimeSheet(isCreated, this.displayName).subscribe(
      (response) => {
        // Handle success
        this.updateTimeType();
        this.updateTimeEntries();
        this.dialogRef.close();
      },
      (error) => {
        // Handle error
        console.warn('Error creating time sheet:', error);
        this.dialogRef.close();
      }
    );
  }

  getTimeEntries(): Observable<TimeEntries> {
    return this.privateService.getTimeEntries();
  }

  async updateTimeEntries() {
    try {
      const data: TimeEntries = await this.getTimeEntries().toPromise();
      this.timeEntries = data;
      localStorage.setItem('TimeEntries', JSON.stringify(this.timeEntries));
    } catch (error) {
      console.warn('Error fetching time type:', error);
    }
  }

  getFlexiTimeEntries(): Observable<TimeEntries[]> {
    return this.privateService.getFlexiTimeEntries();
  }

  async updateFlexiTimeEntries() {
    try {
      const data: TimeEntries[] = await this.getFlexiTimeEntries().toPromise();
      this.flexiTimeEntries = data;
      localStorage.setItem('FlexiTimeEntries', JSON.stringify(this.flexiTimeEntries));
    } catch (error) {
      console.warn('Error fetching time type:', error);
    }
  }

  async updateTimeType() {
    try {
      const data = await this.getTimeType().toPromise();
      this.timeType = data.timeType;
      localStorage.setItem('timeType', JSON.stringify(data.timeType));
    } catch (error) {
      console.warn('Error fetching time type:', error);
    }
  }

  insertTime(formData: FormData) {
    const note = this.NoteGroup.value.note;
    const clientID = this.NoteGroup.value.client;
    const branchId = this.NoteGroup.get('branch')?.value ?? 0;
    this.privateService.insertTime(this.time, this.data.timeType, formData, this.deviceModel, note, clientID, branchId).pipe(
      switchMap(() => this.privateService.getTimeType())
    ).subscribe(
      (response) => {
        this.handleInsertTimeAndTimeTypeResponse(response);
        this.updateTimeEntries();
        this.triggerObservable.complete();
        this.closeWebCam();
        this.dialogRef.close();
      },
      (error) => {
        console.error('Error:', error);
        this.dialogRef.close();
      }
    );
  }

  insertTimeFlexi(formData: FormData) {
    let note = this.NoteGroup.value.note;
    let clientID = this.NoteGroup.value.client;
    let card = this.NoteGroup.get('card').value;
    const branchId = this.NoteGroup.get('branch')?.value ?? 0;

    if (!this.accountInfo.isAllowClient || clientID === undefined || card === undefined || clientID === null) {
      clientID = 0;
      this.NoteGroup.get('client').setValue(0);
    }

    this.privateService.insertFlexiTime(this.time, this.data.timeType, formData, this.deviceModel, note, clientID, card, this.data.location, branchId).pipe(
      switchMap(() => this.privateService.getTimeType())
    ).subscribe(
      (response) => {
        this.getAccountInfo();
        this.handleInsertTimeAndTimeTypeResponse(response);
        this.updateFlexiTimeEntries();
        this.triggerObservable.complete();
        this.closeWebCam();
        this.dialogRef.close();
      },
      (error) => {
        console.error('Error:', error);
        this.dialogRef.close();
      }
    );
  }

  private handleInsertTimeAndTimeTypeResponse(response: any): void {
    const timeType = response.timeType;
    localStorage.setItem('timeType', JSON.stringify(timeType));
  }

  closeWebCam() {
    this.triggerObservable.complete();
    this.showCamera = false;
    this.permissionGranted = false;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.updateWindowSize();
  }

  updateWindowSize() {
    if (window.innerWidth < 500) {
      this.yourDesiredHeight = 230;
      this.yourDesiredWidth = 230;
    } else {
      this.yourDesiredHeight = 350;
      this.yourDesiredWidth = 350;
    }
  }

  public get videoOptions(): MediaTrackConstraints {
    const result: MediaTrackConstraints = {};
    if (this.facingMode && this.facingMode !== '') {
      result.facingMode = { ideal: this.facingMode };
    }
    return result;
  }

  ngOnDestroy() {
    this.triggerObservable.complete();
    this.closeWebCam();
  }
}
